import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {PRODUCT_REVIEW_RETURNS_AND_DEPOSITS_SECTION} from '../productReviewDataMap'

export const ReturnsDepositsSection = () => {
  return (
    <ProductReviewSection title="Returns & Deposits" icon="monetization_on">
      <ProductReviewData sections={[PRODUCT_REVIEW_RETURNS_AND_DEPOSITS_SECTION]} />
    </ProductReviewSection>
  )
}
